import {Star} from 'lucide-react';
import {icons} from '@icons/icons.js';

export const Categories = [
    {
        id: 'popular',
        label: 'Popular',
        icon: <Star size={22} color='#FFB84D' fill='#FFB84D' strokeWidth={2}/>,
    },
    {id: 'ice-cream', label: 'Helados', icon: icons.CopaHelado},
    {id: 'desserts', label: 'Postres', icon: icons.pastel},
    {id: 'healthy-smoothies', label: 'Batidos Saludables', icon: icons.batidoSaludable},
    {id: 'slushies', label: 'Bebidas Granizadas', icon: icons.bebidaGranizada},
    {id: 'ermita-products', label: 'Productos Ermita', icon: icons.productosErmita},
    {id: 'milkshakes', label: 'Malteada', icon: icons.malteada},
    {id: 'natural-juice', label: 'Jugo Natural', icon: icons.jugoNatural},
];